import { subscribe } from "../emitter-subscriber/subscribe";
import { deleteConfig } from "../config/config-store";
import { getApp } from "../experience.utils";
/**
 * Creates a configuration object containing a flush subscription function.
 *
 * The `flushSubscription` function subscribes to the "AAT_FLUSH_PASSIVE" event
 * and processes the payload to determine the application name. If a valid
 * application name is found, it deletes the corresponding configuration.
 *
 * @returns An object containing the `flushSubscription` function.
 */
const createConfig = () => {
    const flushSubscription = () => {
        subscribe("AAT_FLUSH_PASSIVE", (payload) => {
            const appName = payload ? payload.key : getApp();
            console.log(appName);
            if (appName)
                deleteConfig(appName);
        });
    };
    return { flushSubscription };
};
export const { flushSubscription } = createConfig();



//////////////////
// WEBPACK FOOTER
// ./~/@celine/passive-tracking/dist/events/flush.js
// module id = ./node_modules/@celine/passive-tracking/dist/events/flush.js
// module chunks = 0